import { createActions, createState, createReducer } from 'reduxsauce-crud'
import moment from 'moment'
import R, { findIndex, propEq, path } from 'ramda'

const sortBalanceArray = (state, newCharge, isMultiple = false) => {
  const newBalance =
    isMultiple ? [...newCharge, ...state.get.results.data] : [newCharge, ...state.get.results.data]

  return newBalance.sort((transactionA, transactionB) => {
    const dateA = moment(transactionA.registered_at)
    const dateB = moment(transactionB.registered_at)

    if (dateA.isBefore(dateB)) return 1

    return -1
  })
}

const d = { deep: true }

/* ------------- Selectors ------------- */

const getStudentReceipts = state => (path(['balance', 'receipts', 'results'], state) || [])

export const Selectors = {
  getStudentReceipts,
}

export const BalanceRedux = createActions(
  {
    // Custom actions
    createChargeRequest: ['studentId', 'charges'],
    createChargeSuccess: ['results'],
    createChargeError: ['error'],
    deleteChargeRequest: ['chargeId'],
    deleteChargeSuccess: ['results'],
    deleteChargeError: ['error'],
    changeChargeRequest: ['chargeId'],
    changeChargeSuccess: ['results'],
    changeChargeError: ['error'],
    deletePaymentRequest: ['paymentId'],
    deletePaymentSuccess: ['results'],
    deletePaymentError: ['error'],
    createDiscountRequest: ['chargeId', 'data'],
    createDiscountSuccess: ['response'],
    createDiscountError: ['error'],
    adjustDiscountRequest: ['chargeId', 'data'],
    adjustDiscountSuccess: ['response'],
    adjustDiscountError: ['error'],
    adjustTransactionRequest: ['receiptId', 'data'],
    adjustTransactionSuccess: ['response'],
    adjustTransactionError: ['error'],
    createPaymentRequest: ['studentId', 'payment'],
    createPaymentSuccess: ['newCharge'],
    createPaymentError: ['error'],
    createReceiptRequest:['studentId'],
    createReceiptSuccess:['results'],
    createReceiptError:['error'],
    getUnvalidatedReceiptsRequest: ['studentId'],
    getUnvalidatedReceiptsSuccess: ['results'],
    getUnvalidatedReceiptsError: ['error'],
    getValidatedReceiptsRequest: ['studentId','query'],
    getValidatedReceiptsSuccess: ['results'],
    getValidatedReceiptsError: ['error'],
    linkChargeToReceiptRequest: ['chargeId', 'receiptId'],
    linkChargeToReceiptSuccess: ['response'],
    linkChargeToReceiptError: ['error'],
    unlinkChargeToReceiptRequest: ['chargeId', 'receiptId'],
    unlinkChargeToReceiptSuccess: ['response'],
    unlinkChargeToReceiptError: ['error'],
    getMoreRequest: ['params'],
    getMoreSuccess: ['balance'],
    getMoreError: ['error'],
    resetError: [],
    setReceitps:[],
  },
  {
    prefix: 'BALANCE_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = BalanceRedux
export const BalanceTypes = Types
export default Creators

export const INITIAL_STATE = createState({
// custom state
  create: {
    fetching: false,
    error: null,
  },
  discount: {
    fetching: false,
    error: null,
  },
  transaction: {
    fetching: false,
    error: null,
  },
  receipts: {
    fetching: false,
    results: [],
    error: null,
  },
  receiptsValidated: {
    fetching: false,
    results: [],
    error: null,
  },
  getting: {
    fetching: false,
    error: null,
  },
},
{
  get: true,
})


const setReceitps = state => state.merge({ receiptsValidated: { fetching: false, results: [], error: null, } }, d)

const getMoreRequest = state => state.merge({ get: { fetching: true, error: null } }, d)
const getMoreSuccess = (state, { balance }) => {
  // let newBalance = R.clone(state.get.results)
  // newBalance.transactions = [...newBalance.transactions,...balance.transactions]
  return state.merge({ getting: { fetching: false, error: null }, get: {fetching:false ,results: balance } }, d)
}
const getMoreError = (state, { error }) => state.merge({ get: { fetching: false, error } }, d)

const createChargeRequest = state => state.merge({ create: { fetching: true, error: null } }, d)

const createChargeSuccess = (state) =>
  state.merge({ create: { fetching: false, error: null }}, d)

const createChargeError = (state, { error }) =>
  state.merge({ create: { fetching: false, error } }, d)

const deleteChargeRequest = state => state.merge({ create: { fetching: true, error: null } }, d)

const deleteChargeSuccess = (state) =>
  state.merge({ create: { fetching: false, error: null } }, d)

const deleteChargeError = (state, { error }) =>
  state.merge({ create: { fetching: false, error } }, d)

const changeChargeRequest = state => state.merge({ create: { fetching: true, error: null } }, d)

const changeChargeSuccess = (state) =>
  state.merge({ create: { fetching: false, error: null } }, d)

const changeChargeError = (state, { error }) =>
  state.merge({ create: { fetching: false, error } }, d)

const deletePaymentRequest = state => state.merge({ create: { fetching: true, error: null } }, d)

const deletePaymentSuccess = (state) =>
  state.merge({ create: { fetching: false, error: null } }, d)

const deletePaymentError = (state, { error }) =>
  state.merge({ create: { fetching: false, error } }, d)

const createDiscountRequest = state => state.merge({ discount: { fetching: true, error: null } }, d)

const createDiscountSuccess = (state, { response }) => {
  const balance = R.clone(state.get.results.data)
  const transactionIndex = findIndex(propEq('id', response.data.data.id))(balance.transactions)
  balance.transactions[transactionIndex].discount = response.data.data.discount
  return state.merge({ discount: { fetching: false, error: null }, get: { results: balance } }, d)
}

const createDiscountError = (state, { error }) =>
  state.merge({ discount: { fetching: false, error } }, d)

const adjustDiscountRequest = state => state.merge({ discount: { fetching: true, error: null } }, d)

const adjustDiscountSuccess = (state, { response }) => {
  const transactions = R.clone(state.get.results.data)
  const transactionIndex = findIndex(propEq('id', response.data.data.id))(transactions.transactions)
  transactions.transactions[transactionIndex] = response.data.data
  return state.merge({
    discount: { fetching: false, error: null },
    get: { results: transactions },
  }, d)
}

const adjustDiscountError = (state, { error }) =>
  state.merge({ discount: { fetching: false, error } }, d)

const adjustTransactionRequest = state =>
  state.merge({ transaction: { fetching: true, error: null } }, d)

const adjustTransactionSuccess = state =>
  state.merge({ transaction: { fetching: false, error: null } }, d)

const adjustTransactionError = (state, { error }) =>
  state.merge({ transaction: { fetching: false, error } }, d)

const resetError = state => state.merge({ create: { fetching: false, error: null } }, d)

const createPaymentSuccess = (state, { newCharge }) => {
  const newBalance = sortBalanceArray(state, newCharge, true)
  const balance = R.clone(state.get.results.data)
  for (let i = 1; i < newBalance.length; i += 1) {
    balance.transactions.unshift(newBalance[i])
  }
  return state.merge({ create: { fetching: false, error: null }, get: { results: balance } }, d)
}
const createPaymentRequest = state => state.merge({ create: { fetching: true, error: null } }, d)
const createPaymentError = (state, { error }) =>
  state.merge({ create: { fetching: false, error } }, d)

const createReceiptRequest = state =>
  state.merge({ receipts: { fetching: true, error: null } }, d)

const createReceiptSuccess = (state, { results }) =>
  state.merge({ receipts: { fetching: false, error: null, results} }, d)

const createReceiptError = (state, { error }) =>
  state.merge({ receipts: { fetching: false, error} }, d)


const getUnvalidatedReceiptsRequest = state =>
  state.merge({ receipts: { fetching: true, error: null } }, d)

const getUnvalidatedReceiptsSuccess = (state, { results }) =>
  state.merge({ receipts: { fetching: false, error: null, results } }, d)

const getUnvalidatedReceiptsError = (state, { error }) =>
  state.merge({ receipts: { fetching: false, error, results:[] } }, d)

const getValidatedReceiptsRequest = state =>
  state.merge({ receiptsValidated: { fetching: true, error: null, results:[] } }, d)

const getValidatedReceiptsSuccess = (state, { results }) =>
  state.merge({ receiptsValidated: { fetching: false, error: null, results } }, d)

const getValidatedReceiptsError = (state, { error }) =>
  state.merge({ receiptsValidated: { fetching: false, error, results:[] } }, d)

const linkChargeToReceiptRequest = state =>
  state.merge({ receipts: { fetching: true, error: null } }, d)

const linkChargeToReceiptSuccess = state =>
  state.merge({ receipts: { fetching: false, error: null } }, d)

const linkChargeToReceiptError = (state, { error }) =>
  state.merge({ receipts: { fetching: false, error } }, d)

const unlinkChargeToReceiptRequest = state =>
  state.merge({ receipts: { fetching: true, error: null } }, d)

const unlinkChargeToReceiptError = (state, { error }) =>
  state.merge({ receipts: { fetching: false, error } }, d)

const unlinkChargeToReceiptSuccess = state =>
  state.merge({ receipts: { fetching: false, error: null } }, d)

export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.createChargeRequest]: createChargeRequest,
    [Types.createChargeSuccess]: createChargeSuccess,
    [Types.createChargeError]: createChargeError,
    [Types.deleteChargeRequest]: deleteChargeRequest,
    [Types.deleteChargeSuccess]: deleteChargeSuccess,
    [Types.deleteChargeError]: deleteChargeError,
    [Types.changeChargeRequest]: changeChargeRequest,
    [Types.changeChargeSuccess]: changeChargeSuccess,
    [Types.changeChargeError]: changeChargeError,
    [Types.deletePaymentRequest]: deletePaymentRequest,
    [Types.deletePaymentSuccess]: deletePaymentSuccess,
    [Types.deletePaymentError]: deletePaymentError,
    [Types.createDiscountRequest]: createDiscountRequest,
    [Types.createDiscountSuccess]: createDiscountSuccess,
    [Types.createDiscountError]: createDiscountError,
    [Types.adjustDiscountRequest]: adjustDiscountRequest,
    [Types.adjustDiscountSuccess]: adjustDiscountSuccess,
    [Types.adjustDiscountError]: adjustDiscountError,
    [Types.adjustTransactionRequest]: adjustTransactionRequest,
    [Types.adjustTransactionSuccess]: adjustTransactionSuccess,
    [Types.adjustTransactionError]: adjustTransactionError,
    [Types.createPaymentSuccess]: createPaymentSuccess,
    [Types.createPaymentRequest]: createPaymentRequest,
    [Types.createPaymentError]: createPaymentError,
    [Types.createReceiptRequest]: createReceiptRequest,
    [Types.createReceiptSuccess]: createReceiptSuccess,
    [Types.createReceiptError]: createReceiptError,
    [Types.getUnvalidatedReceiptsRequest]: getUnvalidatedReceiptsRequest,
    [Types.getUnvalidatedReceiptsSuccess]: getUnvalidatedReceiptsSuccess,
    [Types.getUnvalidatedReceiptsError]: getUnvalidatedReceiptsError,
    [Types.getValidatedReceiptsRequest]: getValidatedReceiptsRequest,
    [Types.getValidatedReceiptsSuccess]: getValidatedReceiptsSuccess,
    [Types.getValidatedReceiptsError]: getValidatedReceiptsError,
    [Types.linkChargeToReceiptRequest]: linkChargeToReceiptRequest,
    [Types.linkChargeToReceiptSuccess]: linkChargeToReceiptSuccess,
    [Types.linkChargeToReceiptError]: linkChargeToReceiptError,
    [Types.unlinkChargeToReceiptRequest]: unlinkChargeToReceiptRequest,
    [Types.unlinkChargeToReceiptSuccess]: unlinkChargeToReceiptSuccess,
    [Types.unlinkChargeToReceiptError]: unlinkChargeToReceiptError,
    [Types.resetError]: resetError,
    [Types.getMoreRequest]: getMoreRequest,
    [Types.getMoreSuccess]: getMoreSuccess,
    [Types.getMoreError]: getMoreError,
    [Types.setReceitps]: setReceitps,

  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/BalanceRedux.js